/**
 * Js handle for Real Estate Property
 */
import realpressTabSection from './edit-property/tab-section';
import realpressPropertyTaxonomy from './edit-property/taxonomy';
import realpressMap from './edit-property/map';
import realpressFloor from './edit-property/floor';
import realpressValidateForm from './edit-property/validate-form';
import realpressAgent from './edit-property/agent-metabox';
import realpressMedia from '../mixins/media';
import realpressAdditionalFields from './mixins/additional-fields';

document.addEventListener('DOMContentLoaded', (event) => {
    realpressTabSection();
    realpressAdditionalFields();
    realpressPropertyTaxonomy();
    realpressFloor();
    realpressAgent();
    realpressMedia();
    realpressMap();
    realpressValidateForm();
});
